var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconKontrakUnselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49891 18.5031H5.16419C4.24333 18.5031 3.49683 17.7566 3.49683 16.8358V5.16423C3.49683 4.24337 4.24333 3.49687 5.16419 3.49687H15.1684C16.0892 3.49687 16.8357 4.24337 16.8357 5.16423V7.66527",
    stroke: "#9AA2B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 18.5031L13.1876 18.233C13.3415 18.214 13.4847 18.1442 13.5944 18.0346L18.895 12.7341C19.482 12.1495 19.4843 11.1997 18.9 10.6123L18.895 10.6082V10.6082C18.3104 10.0211 17.3606 10.0188 16.7732 10.6032V10.6082L11.5211 15.8604C11.4142 15.9665 11.3451 16.1047 11.3243 16.2539L11 18.5031Z",
    stroke: "#9AA2B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66526 15.1684V15.1684C6.97461 15.1684 6.41473 14.6085 6.41473 13.9179V13.9179C6.41473 13.2272 6.97461 12.6674 7.66526 12.6674V12.6674C8.3559 12.6674 8.91578 13.2272 8.91578 13.9179V13.9179C8.91578 14.6085 8.3559 15.1684 7.66526 15.1684Z",
    stroke: "#9AA2B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41473 6.83159H13.0842",
    stroke: "#9AA2B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41473 9.74948H9.74946",
    stroke: "#9AA2B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKontrakUnselected);
export default __webpack_public_path__ + "static/media/icon_kontrak_unselected.fda087a65051f85eb708ab4d54ecd484.svg";
export { ForwardRef as ReactComponent };